import script from "./ExposicaoOmashuTicket.vue?vue&type=script&setup=true&lang=js"
export * from "./ExposicaoOmashuTicket.vue?vue&type=script&setup=true&lang=js"

import "./ExposicaoOmashuTicket.vue?vue&type=style&index=0&id=1812390c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1812390c"]])

export default __exports__